import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import '@sim/datacube-ui-library/dist/datacube.css';
import ui_lib, { notifications, vuetify } from '@sim/datacube-ui-library';
import axios from "axios";

Vue.config.productionTip = false;

Vue.use(ui_lib);
Vue.use(notifications, { store });

axios.interceptors.response.use(response => response, error => {
	if (axios.isCancel(error)) {
		return Promise.reject(error)
  }

  Vue.prototype.$notify(error.message, 'error')
  return Promise.reject(error)
})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app');
